<template>
  <div class="wg-col wg-xs-12" style="padding: 2%">
    <div style="font-size: 24px" class="com-anm22-app-text-m">
      {{ $anm22.strLang(lang, "Ticket boxes", "Buste accrediti") }}
    </div>
    <div class="vertical-height-div" style="height: 20px"></div>
    <div class="wg-row tickets-list-menu">
      <WGPageControls
        :offset="pageOffset"
        :limit="pageResultsNum"
        :itemsNum="totalResultsNum"
        :language="lang"
        :prevPageClick="prevPage"
        :nextPageClick="nextPage"
        :firstPageClick="firstPage"
        :lastPageClick="lastPage"
      ></WGPageControls>
    </div>
    <div class="vertical-height-div" style="height: 20px"></div>
    <div v-if="listFilters.length" class="display-flex">
      <div
        v-for="(filter, index) in listFilters"
        :key="'filter' + index"
        class="display-flex list-filter"
      >
        <div class="com-anm22-app-text-m" style="white-space: nowrap">
          {{ filter }}
        </div>
        <div class="color-selected" style="margin-left: 10px">
          <img
            class="com-anm22-app-img-fixed-height-s"
            :src="$anm22.icons.getWorldIcon('deleteBlack')"
            style="cursor: pointer"
            @click="removeFilter(filter)"
          />
        </div>
      </div>
      <div class="vertical-height-div" style="height: 20px"></div>
    </div>
    <div class="boxes-list">
      <div class="wg-row ticket-row header">
        <div class="name">{{ $anm22.strLang(lang, "Company", "Azienda") }}</div>
        <div class="name">{{ $anm22.strLang(lang, "Type", "Tipo") }}</div>
        <div class="name">{{ $anm22.strLang(lang, "To delivery/Total", "Da consegnare/totale") }}</div>
        <div class="physicalPass"></div>
        <div class="bracelet"></div>
      </div>
      <div
        class="wg-row ticket-row"
        v-for="(box, index) in boxesList"
        :key="index"
        @click="selectTicket(ticket)"
      >
        <div class="name">{{ box.name }}</div>
        <div class="name">
          {{
            ticketTypes.filter((t) => t.idWorldCardType == box.cardType)[0]
              .name
          }}
        </div>
        <div class="name">{{ box.passToMark }} / {{ box.quantity }}</div>
        <div class="physical-pass">
          <img
            v-if="
              box.passToMark > 0 &&
              getTicketType(box) &&
              getTicketType(box).requiredBracelet
            "
            :src="$anm22.icons.getWorldIcon('card')"
            class="physical-pass-btn not-delivered"
            :title="
              $anm22.strLang(lang, 'Deliver physical pass', 'Consegna pass')
            "
            @click.stop="markBoxesPhysicalTicketStatusByList(box, 'pass')"
          />
        </div>
        <div class="bracelet">
          <img
            v-if="
              box.passToMark > 0 &&
              getTicketType(box) &&
              getTicketType(box).requiredBracelet
            "
            :src="$anm22.icons.getWorldIcon('bracelet')"
            class="bracelet-btn not-delivered"
            :title="
              $anm22.strLang(lang, 'Deliver bracelet', 'Consegna bracciale')
            "
            @click.stop="markBoxesPhysicalTicketStatusByList(box, 'bracelet')"
          />
        </div>
      </div>
      <div class="empty-list-msg" v-if="!boxes || totalResultsNum == 0">
        {{ $anm22.strLang(lang, "No tickets.", "Nessun biglietto.") }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import WGPageControls from "../../../../world/spa/components/WGPageControls.vue";
import TicketPrint from "./TicketPrint.vue";

export default {
  components: {
    WGPageControls,
    TicketPrint,
  },
  data() {
    return {
      boxes: [],
      ticketTypes: [],
      mode: "edit",
      openModal: false,
      showBundleModal: false,
      currentTicket: {},
      currentBundle: {},
      pageResultsNum: 50,
      pageOffset: 0,
      totalResultsNum: 0,
      listFilters: [],
      ticketTab: "main",
      ticketLogs: [],
      printRequestTrigger: 0,
      bundlePresetLoading: false,
      showUpdatedBadge: false,
      bundlePresets: [],
    };
  },
  computed: {
    ...mapState({
      lang: (state) => state.lang,
      windowWidth: (state) => state.windowWidth,
    }),
    boxesList() {
      return this.boxes;
    },
    bundleTicketTypesList() {
      return this.ticketTypes
        .filter((t) => !t.deleted)
        .sort((a, b) => {
          if (a.isPermanent < b.isPermanent) return 1;
          if (a.isPermanent > b.isPermanent) return -1;
          if (a.isVehicle < b.isVehicle) return -1;
          if (a.isVehicle > b.isVehicle) return 1;
          if (a.isFood < b.isFood) return -1;
          if (a.isFood > b.isFood) return 1;
          if (a.name < b.name) return -1;
          if (a.name > b.name) return 1;
          return 0;
        });
    },
    currentTicketBirthday: {
      get() {
        return this.$moment
          .unix(this.currentTicket.birthday)
          .format("YYYY-MM-DD");
      },
      set: _.debounce(function (newVal) {
        this.currentTicket.birthday = Number(
          this.$moment(newVal + " 12:00")
            .utc()
            .format("X"),
        );
      }, 1000),
    },
  },
  methods: {
    searchFn(string) {
      let results = [
        {
          label: string,
          img: this.$anm22.icons.getWorldIcon("searchLeft"),
          submitFn: () => {
            this.addFilter(string);
          },
        },
      ];
      return results;
    },
    loadData() {
      let controllerUrl =
        "tickets/boxes?work=4432&offset=" + this.pageOffset + "&limit=" + this.pageResultsNum;
      if (this.listFilters.length) {
        controllerUrl += "&filters=";
        for (var f = 0; f < this.listFilters.length; f++) {
          controllerUrl += encodeURI(this.listFilters[f]) + ",";
        }
      }
      this.$http
        .get(controllerUrl)
        .then((response) => {
          this.boxes = response.data.boxes;
          this.ticketTypes = response.data.cardTypes;
          this.totalResultsNum = response.data.boxesNum;
          if (this.pageOffset >= this.totalResultsNum) {
            this.lastPage();
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    loadCurrentTicket() {
      let controllerUrl = "tickets/get?id=" + this.currentTicket.idWorldCard;
      this.$http
        .get(controllerUrl)
        .then((response) => {
          this.currentTicket = response.data.card;
          this.ticketLogs = response.data.logs;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    add() {
      this.currentTicket = {};
      this.openModal = true;
      this.mode = "new";
      this.ticketTab = "main";
    },
    openBundleModal() {
      this.currentBundle = {
        types: {},
      };
      this.showBundleModal = true;
    },
    markBoxesPhysicalTicketStatusByList(box, type) {
      this.$http
        .post(
          "tickets/boxes-delivery?work=4432",
          {
            box,
            passType: type
          },
          {
            withCredentials: true,
          },
        )
        .then((response) => {
          this.loadData();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    selectTicket(ticket) {
      this.mode = "edit";
      this.openModal = true;
      this.currentTicket = ticket;
      this.loadCurrentTicket();
      this.ticketTab = "main";
    },
    closeModal() {
      this.loadData();
      this.openModal = false;
      this.showBundleModal = false;
    },
    changeTicketTab(tab) {
      this.ticketTab = tab;
    },
    nextPage() {
      if (this.pageOffset + this.pageResultsNum < this.totalResultsNum) {
        this.pageOffset += this.pageResultsNum;
      }
      this.loadData();
    },
    prevPage() {
      if (this.pageOffset > 0) {
        this.pageOffset -= this.pageResultsNum;
      }
      this.loadData();
    },
    firstPage() {
      this.pageOffset = 0;
      this.loadData();
    },
    lastPage() {
      if (this.totalResultsNum <= 0) {
        this.pageOffset = 0;
      } else {
        this.pageOffset =
          Math.floor((this.totalResultsNum - 1) / this.pageResultsNum) *
          this.pageResultsNum;
        this.loadData();
      }
    },
    addFilter(filter) {
      this.listFilters.push(filter);
      this.loadData();
    },
    removeFilter(filterToRemove) {
      this.listFilters = this.listFilters.filter((f) => f !== filterToRemove);
      this.loadData();
    },
    getTicketType(ticket) {
      let types = this.ticketTypes.filter(
        (t) => t.idWorldCardType == ticket.cardType,
      );
      return types ? types[0] : null;
    },
    sendTicket() {
      let controllerUrl =
        "https://com-anm22-civ.anm22.it/controllers/pass-send-via-email?t=" +
        this.currentTicket.idWorldCard;
      this.$http
        .get(controllerUrl)
        .then((response) => {
          this.changeTicketTab("main");
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  created() {
    this.loadData();
  },
  mounted() {
    this.$anm22.eventBus.$emit("world-headbar-search-config", {
      hintFn: this.searchFn,
    });
  },
};
</script>

<style lang="scss" scoped>
.boxes-list {
  overflow-x: auto;

  .ticket-row {
    border-radius: 8px;
    min-height: 49px;
    padding: 5px;
    flex-wrap: nowrap;
    max-width: 1700px;

    &:hover {
      background-color: #f9f9f9;
    }
    div {
      display: inline-block;
      vertical-align: top;
      white-space: normal;
      padding: 11px;

      &.code {
        flex: 1;
        width: 10%;
        min-width: 60px;
        word-wrap: break-word;
      }
      &.name {
        flex: 3;
        width: 15%;
        min-width: 120px;
      }
      &.category {
        flex: 1;
        width: 15%;
        min-width: 120px;
      }
      &.quantity {
        width: 10%;
        min-width: 60px;
      }
      &.color {
        width: 42px;

        .color-preview {
          border: 1px solid #ddd;
          border-radius: 10px;
          box-sizing: border-box;
          width: 16px;
          height: 16px;
          padding: 0;
        }
      }
      &.edit,
      &.delete,
      &.bracelet,
      &.physical-pass {
        padding: 8px;
        width: 36px;

        .edit-btn,
        .delete-btn,
        .bracelet-btn,
        .physical-pass-btn {
          width: 20px;
          height: 20px;
          cursor: pointer;
        }

        .bracelet-btn,
        .physical-pass-btn {
          &.not-delivered {
            opacity: 0.3;

            &:hover {
              opacity: 1;
            }
          }
          &.delivered {
            cursor: default;
          }
        }
      }

      @media (max-width: 500px) {
        &.bracelet {
          display: none;
        }
        &.physical-pass {
          display: none;
        }
      }
    }

    &.header {
      div {
        font-weight: 600;
      }

      &:hover {
        background: none !important;
      }
    }
  }

  .empty-list-msg {
    padding: 16px;
  }
}

.boxes-list-menu {
  align-items: center;
  max-width: 1700px;
}

.list-filter {
  align-items: center;
  flex-wrap: nowrap;
  background-color: #e9e9ea;
  font-size: 14px;
  padding: 10px;
  border-radius: 10px;
  margin: 5px 10px 5px 0;
  cursor: pointer;
}

.ticket-modal-title {
  vertical-align: middle;
  overflow: hidden;
  text-overflow: ellipsis;
}

.ticket-updated-badge {
  color: #fff;
  background-color: #4caf50;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  display: inline-block;
  vertical-align: middle;
  font-size: 14px;
  text-align: center;
  font-weight: 500;
  box-sizing: border-box;
  padding-top: 2px;
  margin-left: 6px;
  position: absolute;
  top: 14px;
  right: 36px;
}

.ticket-tab-back {
  cursor: pointer;
  font-weight: 500;
  margin-bottom: 20px;
}

.ticket-tab-title {
  font-size: 20px;
  font-weight: 500;
  margin-bottom: 20px;
}

.ticket-action-cards {
  overflow-y: hidden;
  overflow-x: auto;
  white-space: nowrap;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 20px;

  .action-card {
    border: 1px solid #fff;
    border-radius: 6px;
    padding: 6px;
    font-size: 14px;
    font-weight: 500;
    width: 100px;
    min-width: 100px;
    height: 60px;
    white-space: normal;
    user-select: none;
    overflow: hidden;
    background-repeat: no-repeat;
    background-position: 75px 38px;
    background-size: 16px auto;

    &.link {
      border: 1px solid #ccc;
      cursor: pointer;

      &:hover {
        border: 1px solid #aaa;
      }
    }

    &.inside {
      background-color: #42a5f5;
    }
    &.done {
      background-color: #76ff03;
      background-image: url("https://www.anm22.it/app/world/libs/anm22_icons/img/icons/done.svg");
    }
    &.warning {
      background-color: #ffc400;
      background-image: url("https://www.anm22.it/app/world/libs/anm22_icons/img/icons/warning.svg");
    }
    &.error {
      position: relative;
      background-color: #d50000;
      color: #fff;
    }
    &.email {
      background-image: url("https://www.anm22.it/app/world/libs/anm22_icons/img/icons/email.svg");
    }
    &.list {
      background-image: url("https://www.anm22.it/app/world/libs/anm22_icons/img/icons/list.svg");
    }
    &.bracelet {
      background-image: url("https://civ.anm22.it/img/icons/fitness-tracker.svg");
    }
    &.print {
      background-image: url("https://www.anm22.it/app/world/libs/anm22_icons/img/icons/printer.svg");
    }
  }
}

.ticket-id {
  margin-bottom: 20px;
  font-size: 16px;
  font-weight: 500;
}

.verified-badge {
  display: inline-block;
  vertical-align: middle;
  height: 16px;
  margin-left: 8px;
}

input[type="button"]:disabled {
  opacity: 0.5;
  cursor: default;

  &:hover {
    background-color: #e9e9ea;
  }
}

.logs-list {
  margin-bottom: 20px;

  .log-item {
    margin-bottom: 5px;
  }
}

.bracelet-tab {
  input[type="button"] {
    margin: 6px;
  }
}

.bundle-presets-list {
  .bundle-preset {
    align-items: center;
    flex-wrap: nowrap;
    background-color: #e9e9ea;
    font-size: 14px;
    padding: 10px;
    border-radius: 10px;
    margin: 5px 10px 5px 0;
    user-select: none;
    cursor: pointer;

    &:hover {
      background-color: #ddd;
    }
  }
}

.bundle-ticket-types {
  .bundle-ticket-type {
    margin: 2px 0;

    input {
      margin-right: 8px;
    }

    .ticket-type-ic {
      display: inline-flex;
      text-align: center;
      width: 20px;
      height: 20px;
      margin-right: 8px;
    }
  }
}
</style>
